import type { Step } from '../types';

const STEPS: Step[] = [
    {
        number: '01',
        title: 'Frame Your Decision',
        description: 'Enter your distraction-free Stewardship Dashboard to outline the financial choice or scenario you want to explore.',
    },
    {
        number: '02',
        title: 'Choose Your Lenses',
        description: 'Select your AI personas (Magnolia, Camellia, Peony) to debate risks and analyze the scenario from multiple structural angles.',
    },
    {
        number: '03',
        title: 'Reflect and Decide',
        description: 'Review comprehensive, Guardian-vetted insights. Take the time you need to make calm, well-informed choices for your family.',
    },
];

export const HowItWorks = () => {
    return (
        <section className="how-it-works section section--alt" id="how-it-works">
            <div className="container">
                <div className="section__header">
                    <span className="section__badge">How It Works</span>
                    <h2 className="section__title">Structured Reflection, <br />Clearer Decisions</h2>
                    <p className="section__description">Navigate complex financial choices through our structured, <br />distraction-free environment.</p>
                </div>

                <div className="steps">
                    {STEPS.map((step) => (
                        <div key={step.number} className="step">
                            <div className="step__number">{step.number}</div>
                            <div className="step__content">
                                <h3 className="step__title">{step.title}</h3>
                                <p className="step__description">{step.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};